<template>
  <Dialog header="Settings" v-model:visible="enabled" modal maximizable dismissableMask :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '90vw', height: '80vh'}" 
  :contentStyle="{ height: 'calc(90vh - 4rem)', overflow: 'auto' }">
    <TabView :activeIndex="0">
      <TabPanel header="Theme">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="mr-2">Color Mode</label>
            <Dropdown class="inputfield" v-model="colorModeSelected" :options="colorModeOptions" optionLabel="name" optionValue="value"/>
          </div>
          <!--
          <div class="field col-4 field-checkbox">
            <label class="mr-2">Ascending</label>
            <Checkbox class="inputfield" v-model="colorAscending" :binary="true"/>
          </div> -->
          <div class="field col-12" v-if="colorModeSelected == 'interpolate'">
            <label class="mr-2">Interpolate 1</label>
            <ColorPicker v-model="color1" />
          </div>
          <div class="field col-12" v-if="colorModeSelected == 'interpolate'">
            <label class="mr-2">Interpolate 2</label>
            <ColorPicker v-model="color2" />
          </div>
        </div>
      </TabPanel>

      <TabPanel header="UI Settings">
        <div class="formgrid grid">

          <div class="field col-12" style="display:flex;align-items:center;gap:.75rem;margin:.5rem 0;">
            <label for="sw2" style="width: 180px;">Enabled properties</label>
            <InputSwitch id="sw2" v-model="uiSettingsConfigValue.enabledProperties" />
            <span>{{ uiSettingsConfigValue.enabledProperties ? 'On' : 'Off' }}</span>
          </div>

          <div class="field col-12" style="display:flex;align-items:center;gap:.75rem;margin:.5rem 0;">
            <label for="sw2" style="width: 180px;">Enabled color code</label>
            <InputSwitch id="sw2" v-model="uiSettingsConfigValue.enabledColorCode" />
            <span>{{ uiSettingsConfigValue.enabledColorCode ? 'On' : 'Off' }}</span>
          </div>

          <div class="field col-12" style="display:flex;align-items:center;gap:.75rem;margin:.5rem 0;">
            <label for="sw2" style="width: 180px;">Enabled IoT</label>
            <InputSwitch id="sw2" v-model="uiSettingsConfigValue.enabledIot" />
            <span>{{ uiSettingsConfigValue.enabledIot ? 'On' : 'Off' }}</span>
          </div>
          
          <div class="field col-12" style="display:flex;align-items:center;gap:.75rem;margin:.5rem 0;">
            <label for="sw2" style="width: 180px;">Enabled filter</label>
            <InputSwitch id="sw2" v-model="uiSettingsConfigValue.enabledFilter" />
            <span>{{ uiSettingsConfigValue.enabledFilter ? 'On' : 'Off' }}</span>
          </div>

          <div class="field col-12 flex mt-2 mb-0 justify-content-between">
            <label>Custom tabs</label>
            <Button label="Reset to default" class="p-button-text p-button-danger" @click="resetCustomTabs" />
          </div>
          <div class="field col-12">
            <JsonEditor :invalid="customTabsError" v-model="customTabsJsonValue" @updateError="customTabsError = $event" rows="25" class="inputfield w-full" />
            <label style="color: var(--yellow-500)" v-if="customTabsError">{{ customTabsError }}</label>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Navigation settings">
          <div class="field col-12 flex mb-0 justify-content-between">
            <label>Navigation config</label>
            <Button label="Reset to default" class="p-button-text p-button-danger" @click="resetNavigationConfig" />
          </div>
          <div class="field col-12">
            <JsonEditor :invalid="navigationConfigError" v-model="navigationConfigJsonValue" @updateError="navigationConfigError = $event" rows="25" class="inputfield w-full" />
            <label style="color: var(--yellow-500)" v-if="navigationConfigError">{{ navigationConfigError }}</label>
          </div>
      </TabPanel>

      <TabPanel header="View templates settings">
          <div class="field col-12 flex mt-2 mb-0 justify-content-between">
            <label>View templates config</label>
            <Button label="Reset to default" class="p-button-text p-button-danger" @click="resetViewTemplatesConfig" />
          </div>
          <div class="field col-12">
            <JsonEditor :invalid="viewTemplatesConfigError" v-model="viewTemplatesConfigJsonValue" @updateError="viewTemplatesConfigError = $event" rows="25" class="inputfield w-full" />
            <label style="color: var(--yellow-500)" v-if="viewTemplatesConfigError">{{ viewTemplatesConfigError }}</label>
          </div>
      </TabPanel>
    </TabView>
    <template #footer>
      <Button class="right-0" :disabled="checkUpdate" label="Update" @click="saveSettings" />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import TabPanel from 'primevue/tabpanel';
import Dropdown from 'primevue/dropdown';
import ColorPicker from 'primevue/colorpicker';
import Button from 'primevue/button';
import InputSwitch from 'primevue/inputswitch';
import { mapActions, mapState } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.cjs.js';
import DEFAULTS from '../../helpers/defaults';
import TabView from 'primevue/tabview';
import JsonEditor from '../Menu/JsonEditor.vue';

export default {
  components: { Dialog, TabView, Button, TabPanel, Dropdown, ColorPicker, InputSwitch, JsonEditor },

  props: ["show"],

  computed: {
    ...mapState('colors', ['colorMode', 'colorAsc', 'interpolate1', 'interpolate2']),
    ...mapGetters("settings", ["customTabsConfig", "uiSettingsConfig", "navigationConfig", "viewTemplatesConfig"]),

    checkUpdate() {
      if (this.customTabsError != null) return true;
      if (this.navigationConfigError != null) return true;
      if (this.viewTemplatesConfigError != null) return true;
      if(this.colorMode != this.colorModeSelected || this.interpolate1 != this.color1 || this.interpolate2 != this.color2) {
        return false;
      }
      if (JSON.stringify(this.customTabsJsonValue) != JSON.stringify(this.customTabsConfig)) {
        return false;
      }
      if (JSON.stringify(this.uiSettingsConfigValue) != JSON.stringify(this.uiSettingsConfig)) {
        return false;
      }
      if (JSON.stringify(this.navigationConfigJsonValue) != JSON.stringify(this.navigationConfig)) {
        return false;
      }
      if (JSON.stringify(this.viewTemplatesConfigJsonValue) != JSON.stringify(this.viewTemplatesConfig)) {
        return false;
      }
      return true;
    }
  },

  methods: {
    ...mapActions('colors', ['setColorSettings']),
    ...mapActions('settings', ['changeCustomTabsJson', 'changeUISettings', "changeNavigationConfigJson", "changeViewTemplatesConfigJson"]),

    saveSettings() {
      this.setColorSettings({
        mode: this.colorModeSelected,
        asc: true, //this.colorAscending,
        interpolate: [this.color1, this.color2],
      });

      this.changeCustomTabsJson(this.customTabsJsonValue);
      this.changeUISettings(this.uiSettingsConfigValue);
      this.changeNavigationConfigJson(this.navigationConfigJsonValue);
      this.changeViewTemplatesConfigJson(this.viewTemplatesConfigJsonValue);
    },

    resetCustomTabs() {
      this.customTabsJsonValue = DEFAULTS.customTabsConfig;
    },

    resetNavigationConfig() {
      this.navigationConfigJsonValue = DEFAULTS.navigationConfig;
    },

    resetViewTemplatesConfig() {
      this.viewTemplatesConfigJsonValue = DEFAULTS.viewTemplatesConfig;
    },
  },

  watch: {
    show() {
      this.enabled = true;
    },
  },

  data() {
    return {
      enabled: false,
      colorModeSelected: null,
      customTabsError: null,
      navigationConfigError: null,
      viewTemplatesConfigError: null,
      // colorAscending: false,
      color1: '#ffffff',
      color2: '#000000',
      customTabsJsonValue: {},
      navigationConfigJsonValue: {},
      viewTemplatesConfigJsonValue: {},
      colorModeOptions: [
        { name: 'Random', value: 'random'},
        { name: 'Interpolate', value: 'interpolate'},
      ],
      uiSettingsConfigValue: null,
    }
  },

  mounted() {
    this.colorModeSelected = this.colorMode;
    this.customTabsJsonValue = this.customTabsConfig;
    this.navigationConfigJsonValue = this.navigationConfig;
    this.viewTemplatesConfigJsonValue = this.viewTemplatesConfig;
    // this.colorAscending = this.colorAsc;
    this.color1 = this.interpolate1;
    this.color2 = this.interpolate2;
    this.uiSettingsConfigValue = { ...this.uiSettingsConfig };
  },

}
</script>

<style>

</style>